import type { DataTableVariant } from './dataTableVariant.js';
import type { DataTableLayoutKind, DataTablePagination } from './types.js';

export function normalizeDataTableVariant(
  variant: DataTableVariant | undefined,
): 'list' | 'embedded' {
  if (variant === 'embedded' || variant === 'preview') return 'embedded';
  return 'list';
}

export function resolveDataTableLayout(options: {
  variant: DataTableVariant | undefined;
  pagination: DataTablePagination | false | undefined;
}): DataTableLayoutKind {
  if (options.pagination === false) {
    return { kind: 'embedded' };
  }
  if (options.pagination) {
    return { kind: 'list' };
  }
  if (normalizeDataTableVariant(options.variant) === 'embedded') {
    return { kind: 'embedded' };
  }
  return { kind: 'list' };
}
